import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LibroDetalle } from 'src/app/modal/catalogo/libro-detalle';
import { NovedadesResponse } from 'src/app/modal/catalogo/novedades-response';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { CarritoHeader } from 'src/app/modal/carrito/carrito-header';
import { environment } from 'src/environments/environment';
import { LibroDetalleBean } from 'src/app/modal/catalogo/libro-detalle-bean';
import {
  HostListener,
  Renderer2,
  ElementRef,
  ChangeDetectorRef,
} from '@angular/core';
import { SeoService, SeoSnapshot } from '../../../../service/seo/seo.service';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { ProtectedImageResponse } from 'src/app/modal/catalogo/protected-image-response';
import { HeaderCommunicationService } from 'src/app/service/header/header-communication.service';
import { CurrencyService, CurrencyInfo } from 'src/app/service/currency/currency.service';
import { EstadisticaService } from 'src/app/service/estadistica/estadistica.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-fotografia-detalle',
  templateUrl: './fotografia-detalle.component.html',
  styleUrls: ['./fotografia-detalle.component.scss'],
})
export class FotografiaDetalleComponent implements OnInit, OnDestroy {
  idLibro: string;
  flgAgregar: string = '0';
  detalleLibro: LibroDetalle = new LibroDetalle();
  stockLibro = 0;
  librosRecomendados: NovedadesResponse;
  cantidadLibro: number = 1;
  precioTotal: number = 1;
  modalidadActiva = 'N';
  currencyActiva = 'S/.'; // Moneda de la modalidad activa

  // Currency service integration
  private currencySubscription: Subscription;
  currentCurrency: CurrencyInfo;
  urlImagen: string;
  // daet ini
  urlImagen2: string;
  urlImagen3: string;
  // daet fin
  // daet1 ini
  comercialMsg: string;
  // daet1 fin
  tagPublicacion: any;
  listModalidad: any;
  modalidadId: any = '1';
  // daet1 ini
  relacionados: any;
  // daet fin
  Arr = Array;
  etiquetasAgrupadas: string[][] = [];
  etiquetasAgrupadas2Col: string[][] = [];
  precioTotalFormat: string;
  private prevSeo!: SeoSnapshot;
  protectedImages: Map<string, ProtectedImageResponse> = new Map();
  modalidadSeleccionada: string;

  // Propiedades del zoom

  // Image loading state (usando el mismo patrón que fotografías)
  private imageUrlCache: Map<string, string | null> = new Map();
  private imageLoadStartTimes: Map<string, number> = new Map();
  private imageReadyForDisplay: Map<string, boolean> = new Map();
  public isSkeletonVisible: Map<string, boolean> = new Map();

  // Control de visibilidad de botones sticky
  showStickyButtons: boolean = false;
  showModalidadMenuCart: boolean = false;
  showModalidadMenuBuy: boolean = false;
  private visitaActivoId: string = null;

  constructor(
    private route: ActivatedRoute,
    private novedadesService: NovedadesService,
    private router: Router,
    private carritoService: CarritoService,
    private usuarioService: UsuarioService,
    private utilitarioService: UtilitarioService,
    private renderer: Renderer2,
    private el: ElementRef,
    private seo: SeoService,
    private protectedImageService: ProtectedImageService,
    private cdr: ChangeDetectorRef,
    private headerCommunicationService: HeaderCommunicationService,
    private currencyService: CurrencyService,
    private estadisticaService: EstadisticaService
  ) {
    //daet
    // console.log('params.idLibro->' + this.route.snapshot.params.idLibro);
    // console.log('params.nothing->' + this.route.snapshot.params.nothing);
    // console.log('idSeleccionado->' + this.utilitarioService.idSeleccionado);

    this.idLibro =
      this.route.snapshot.params.idLibro == null ||
      this.route.snapshot.params.idLibro == undefined
        ? this.utilitarioService.idSeleccionado
        : this.route.snapshot.params.idLibro;
    //this.idLibro=this.route.snapshot.params.idLibro.split("-")[0];
    // console.log('this.idLibro.final->' + this.idLibro);
    // daet
    //this.idLibro=this.route.snapshot.params.idLibro
  }

  obtenerDetalleLibro(id) {
    id = id == null ? this.utilitarioService.idSeleccionado : id;
    //console.log("idSeleccionado"+this.utilitarioService.idSeleccionado);
    // console.log('idSeleccionado.id' + id);

    // Validar que el ID sea numérico
    if (id && !/^\d+$/.test(id.toString())) {
      // console.log('ID no numérico detectado:', id, '- Redirigiendo a 404');
      this.router.navigate(['/404']);
      return;
    }

    if (this.cantidadLibro < 1) {
      this.cantidadLibro = 0;
    }

    if (this.cantidadLibro > 10) {
      this.cantidadLibro = 10;
      this.utilitarioService.toastrInfo('cantidad maxíma : ' + '10');
    }

    this.detalleLibro = new LibroDetalle();
    this.utilitarioService.loading = true;

    // Obtener userId si está logueado para determinar nacionalidad por tipo de documento
    const userId = this.usuarioService.obtenerIDSessionUsuario();
    // console.log('📋 [FOTOGRAFIA-DETALLE] userId para determinar nacionalidad:', userId);

    if (this.cantidadLibro > 0) {
      // console.log('Libro Existe');

      setTimeout(() => {
        this.novedadesService.obtenerDetalleLibro(id, userId).subscribe((data) => {
          // if(this.cantidadLibro>Number(this.detalleLibro.response.list[0].stock)){
          //   this.utilitarioService.toastrWarning("Cantidad Mayor a Stock");
          //   return false;
          // }

          this.detalleLibro = data;
          // console.log('data:' + data);
          // console.log('data.response:', data.response.list[0]);

          // Verificar si no existen datos - redirigir a 404
          if (
            !data ||
            !data.response ||
            !data.response.list ||
            data.response.list.length === 0
          ) {
            // console.log(
              // 'Recurso no encontrado - ID:',
              // id,
              // '- Redirigiendo a 404'
            // );
            this.utilitarioService.loading = false;
            this.router.navigate(['/404']);
            return;
          }

          // ⚠️ asegúrate de que response.list[0] exista:
          const item = this.detalleLibro?.response?.list?.[0];

          // Validar que sea categoría 1 (Fotografías)
          if (item && item.categoryId && String(item.categoryId) !== '1') {
            // console.log(
              // 'Categoría inválida para fotografías. CategoryId:',
              // item.categoryId,
              // '- Redirigiendo a 404'
            // );
            this.utilitarioService.loading = false;
            this.router.navigate(['/404']);
            return;
          }

          if (item) {
            this.setSeoFromDetalle(item);

            // Activar categoría y subcategoría en el header
            this.activateHeaderFromDetail(item);

            // Cargar imagen protegida si tiene activoId
            if (item.activoId) {
              this.loadProtectedThumbnail(String(item.activoId));
            }

            // Registrar visita para estadísticas (se ejecuta tras 3s de permanencia)
            this.visitaActivoId = String(item.id || item.activoId || id);
            this.estadisticaService.registrarVisita(this.visitaActivoId, 'FOTOGRAFIA');
          }

          this.precioTotal = Number(
            (
              this.cantidadLibro *
              Number(this.detalleLibro.response.list[0].price)
            ).toFixed(2)
          );
          const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });

          this.precioTotalFormat = formatter.format(this.precioTotal);

          // Auto-seleccionar modalidad según la moneda detectada por geolocalización
          if (
            this.detalleLibro.response.list[0].modalidades &&
            this.detalleLibro.response.list[0].modalidades.length > 0
          ) {
            this.autoSelectModalidadByCurrency();
          }

          if (Number(this.detalleLibro.response.list[0].quantity) < 10) {
            this.stockLibro = Number(
              this.detalleLibro.response.list[0].quantity
            );
          } else {
            this.stockLibro = 10;
          }

          if (this.detalleLibro.response.list[0].stock == '0') {
            this.cantidadLibro = Number(
              this.detalleLibro.response.list[0].stock
            );
          }

          // daet ini - manteniendo las otras imágenes con el método anterior por ahora
          // ELIMINADO: método antiguo con tokenUserImagen (vulnerabilidad de seguridad)
          // TODO: Migrar a sistema de imágenes protegidas si es necesario
          // this.urlImagen2 = this.imagen(this.detalleLibro.response.list[0].previewUrl);
          // this.urlImagen3 = this.imagen(this.detalleLibro.response.list[0].originalUrl);
          // daet fin
          this.tagPublicacion =
            this.detalleLibro.response.list[0].tags.split(',');
          // Usar el array de modalidades filtradas del backend (basado en geolocalización)
          // en lugar del string modalidadName que contiene todas las modalidades
          const modalidadesArray = this.detalleLibro.response.list[0].modalidades;
          if (modalidadesArray && modalidadesArray.length > 0) {
            this.listModalidad = modalidadesArray.map(m => m.name);
            // console.log('📋 [FOTOGRAFIA-DETALLE] Modalidades filtradas del backend:', this.listModalidad);
          } else {
            // Fallback al string solo si no hay array de modalidades
            this.listModalidad = this.detalleLibro.response.list[0].modalidadName.split('/');
            // console.log('📋 [FOTOGRAFIA-DETALLE] Usando fallback modalidadName:', this.listModalidad);
          }
          // console.log('tagPublicacion', this.tagPublicacion);
          // daet1 ini
          this.relacionados = this.detalleLibro.response.list[0].relacionados;
          // daet1 fin
          this.utilitarioService.loading = false;

          // nlpr ini
          this.dividirEtiquetasEnFilas();
          this.dividirEtiquetasEn2Columnas();
          // nlpr fin
        });
      }, 0); // Usamos setTimeout con un tiempo de 0 para retrasar la ejecución
    } else {
      this.cantidadLibro = 0;
      this.utilitarioService.loading = false;
      // console.log('Libro 0000');
    }
  }

  obtenerDetalleLibroAgregarLibros(id) {
    // console.log(
      // 'cantidadLibro',
      // this.cantidadLibro,
      // Number(this.detalleLibro.response.list[0].quantity)
    // );
    if (
      this.cantidadLibro >
        Number(this.detalleLibro.response.list[0].quantity) ||
      this.cantidadLibro == 0
    ) {
      this.utilitarioService.toastrWarning(
        'Cantidad debe ser estar entre 1 y ' + this.stockLibro
      );
      this.cantidadLibro = this.stockLibro;
      return false;
    }

    if (this.cantidadLibro < 1) {
      this.cantidadLibro = 0;
    }

    if (this.cantidadLibro > 10) {
      this.cantidadLibro = 10;
      this.utilitarioService.toastrInfo('cantidad maxíma : ' + '10');
    }

    this.detalleLibro = new LibroDetalle();
    // this.utilitarioService.loading = true;

    // Obtener userId si está logueado para determinar nacionalidad por tipo de documento
    const userId = this.usuarioService.obtenerIDSessionUsuario();

    if (this.cantidadLibro > 0) {
      setTimeout(() => {
        this.novedadesService.obtenerDetalleLibro(id, userId).subscribe((data) => {
          this.detalleLibro = data;
          // console.log(data);

          // Verificar si no existen datos - redirigir a 404
          if (
            !data ||
            !data.response ||
            !data.response.list ||
            data.response.list.length === 0
          ) {
            // console.log(
              // 'Recurso no encontrado - ID:',
              // id,
              // '- Redirigiendo a 404'
            // );
            this.router.navigate(['/404']);
            return;
          }

          const item = this.detalleLibro?.response?.list?.[0];

          // Validar que sea categoría 1 (Fotografías)
          if (item && item.categoryId && String(item.categoryId) !== '1') {
            // console.log(
              // 'Categoría inválida para fotografías. CategoryId:',
              // item.categoryId,
              // '- Redirigiendo a 404'
            // );
            this.router.navigate(['/404']);
            return;
          }

          this.precioTotal = Number(
            (
              this.cantidadLibro *
              Number(this.detalleLibro.response.list[0].price)
            ).toFixed(2)
          );

          if (Number(this.detalleLibro.response.list[0].quantity) < 10) {
            this.stockLibro = Number(
              this.detalleLibro.response.list[0].quantity
            );
          } else {
            this.stockLibro = 10;
          }

          if (this.detalleLibro.response.list[0].stock == '0') {
            this.cantidadLibro = Number(
              this.detalleLibro.response.list[0].stock
            );
          }

          // this.utilitarioService.loading = false;
        });
      }, 0); // Usamos setTimeout con un tiempo de 0 para retrasar la ejecución
    } else {
      this.cantidadLibro = 0;
    }
  }

  obtenerLibrosRecomendados(id) {
    this.librosRecomendados = new NovedadesResponse();
    this.novedadesService.obtenerLibrosRecomendados(id).subscribe((data) => {
      this.librosRecomendados = data;
    });
  }
  slideConfig = {
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  cargarDetalleLibro(id) {
    this.obtenerDetalleLibro(id);
    // this.obtenerLibrosRecomendados(id); // Comentado - sección de recomendados no se usa
  }

  // daet
  prueba(busq) {
    // console.log('prueba:' + busq);

    // Limpiar espacios del tag
    const cleanTag = busq.trim().toLowerCase();

    this.utilitarioService.busqueda = cleanTag;
    this.utilitarioService.tipobusqueda = 'tag';

    // console.log(
      // 'Navegando desde fotografía-detalle a /consultas con tag:',
      // cleanTag
    // );

    // Navegar a /consultas solo con q y page (igual que fotografías)
    this.router.navigate(['/consultas'], {
      queryParams: { q: cleanTag, page: 1 },
    });
  }
  //daet1
  prueba1(busq) {
    // console.log('prueba1:' + busq);
    //this.utilitarioService.busqueda = busq;
    //this.utilitarioService.tipobusqueda="tag";
    this.obtenerDetalleLibro(busq);
    this.router.navigate(['/dt/' + busq]);
  }
  generaNss() {
    let result = '';
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < charactersLength; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
  toggleModalidadMenuCart(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    // Si hay más de una modalidad, mostrar el menú
    if (this.listModalidad && this.listModalidad.length > 1) {
      this.showModalidadMenuCart = !this.showModalidadMenuCart;
      this.showModalidadMenuBuy = false; // Cerrar el otro menú
    } else {
      // Si solo hay una modalidad, agregar directamente al carrito
      this.agregarCarrito();
    }
  }

  toggleModalidadMenuBuy(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    // Si hay más de una modalidad, mostrar el menú
    if (this.listModalidad && this.listModalidad.length > 1) {
      this.showModalidadMenuBuy = !this.showModalidadMenuBuy;
      this.showModalidadMenuCart = false; // Cerrar el otro menú
    } else {
      // Si solo hay una modalidad, comprar directamente
      this.onComprar();
    }
  }

  selectModalidadAndAddToCart(modalidad: string) {
    this.cambiarModalidad(modalidad);
    this.showModalidadMenuCart = false;
    setTimeout(() => {
      this.agregarCarrito();
    }, 100);
  }

  selectModalidadAndBuy(modalidad: string) {
    this.cambiarModalidad(modalidad);
    this.showModalidadMenuBuy = false;
    setTimeout(() => {
      this.onComprar();
    }, 100);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Cerrar menús si se hace clic fuera
    const target = event.target as HTMLElement;
    if (!target.closest('.sticky-action-buttons')) {
      this.showModalidadMenuCart = false;
      this.showModalidadMenuBuy = false;
    }
  }

  agregarCarrito() {
    if (!this.usuarioService.obtenerSesionUsuario()) {
      // Guardar URL actual para regresar después del login
      this.usuarioService.setReturnUrl(this.router.url);
      this.utilitarioService.toastrWarning(
        'Necesita iniciar sesión para agregar productos al carrito'
      );
      return;
    }

    this.flgAgregar = '1';
    let idLibro = this.detalleLibro.response.list[0].id;
    let cantidad = this.cantidadLibro;
    let tipoProducto = '1';
    let sizeID = '0';

    let libroArray = {};
    libroArray = {
      id: idLibro,
      cantidad: cantidad,
      tipoProducto: tipoProducto,
      sizeID: sizeID,
      modalidadId: this.modalidadId,
    };

    let carritoSesionTemp = new CarritoHeader();
    carritoSesionTemp = this.carritoService.obtenerCarritoCompras();
    for (let i = 0; i < carritoSesionTemp.lista.length; i++) {
      if (
        carritoSesionTemp.lista[i].id == idLibro &&
        this.modalidadId == carritoSesionTemp.lista[i].modalidadId
      ) {
        let cantidadTemp = carritoSesionTemp.lista[i].cantidad;
        let cantidadSumaTemp = Number(cantidadTemp) + Number(cantidad);
        if (Number(cantidadSumaTemp) > this.stockLibro) {
          // console.log(
            // 'cantidadSumaTemp:' +
              // cantidadSumaTemp +
              // '-->this.stockLibro:' +
              // this.stockLibro
          // );
          // daet1
          //this.utilitarioService.toastrWarning("El limite de stock es "+this.stockLibro);
          this.utilitarioService.toastrWarning(
            'Ya se seleccionó la foto ' + this.stockLibro
          );
          return false;
        }
      }
    }
    if (carritoSesionTemp.lista) this.carritoService.agregarCarrito(libroArray);
    this.utilitarioService.toastrSuccess('Agregado al carrito');
  }

  imagen(img: String) {
    // console.log(
      // 'this.detalleLibro.response.list[0]',
      // this.detalleLibro.response.list[0]
    // );

    if (!img) {
      console.warn('Advertencia: La imagen es null o undefined.');
      return ''; // Retornar una cadena vacía para evitar errores
    }
    return img.replace(/_=2?/, '');
  }

  onComprar() {
    if (!this.usuarioService.obtenerSesionUsuario()) {
      // Guardar URL actual para regresar después del login
      this.usuarioService.setReturnUrl(this.router.url);
      this.utilitarioService.toastrWarning(
        'Necesita iniciar sesión para realizar una compra'
      );
      return;
    }

    if (this.usuarioService.obtenerSesionUsuario()) {
      let idLibro = this.detalleLibro.response.list[0].id;
      let cantidad = this.cantidadLibro;
      let tipoProducto = '1';
      let sizeID = '0';
      let libroArray = {};

      cantidad = this.cantidadLibro;

      this.carritoService.obtenerCantidadCarrito();

      // Validar si el producto ya está en el carrito y excede el stock
      let carritoSesionTemp = new CarritoHeader();
      carritoSesionTemp = this.carritoService.obtenerCarritoCompras();
      if (carritoSesionTemp && carritoSesionTemp.lista) {
        for (let i = 0; i < carritoSesionTemp.lista.length; i++) {
          if (
            carritoSesionTemp.lista[i].id == idLibro &&
            this.modalidadId == carritoSesionTemp.lista[i].modalidadId
          ) {
            // El producto ya está en el carrito, mostrar aviso e ir directo a procesar pago
            this.utilitarioService.toastrInfo('El producto ya está en tu carrito');
            this.router.navigate(['/procesarpago']);
            return;
          }
        }
      }

      libroArray = {
        id: idLibro,
        cantidad: cantidad,
        tipoProducto: tipoProducto,
        sizeID: sizeID,
        modalidadId: this.modalidadId,
      };

      // Agregar al carrito y procesar pago
      this.carritoService.agregarCarrito(libroArray);
      this.router.navigate(['/procesarpago']);
    } else {
      this.utilitarioService.toastrWarning('Necesita iniciar sesión');
    }
  }
  cambiarModalidad(modalidad) {
    let modalidades: LibroDetalleBean = this.detalleLibro.response.list[0];
    this.modalidadActiva = modalidad;

    const modalidadSeleccionada = modalidades.modalidades.find(
      (data) => data.name == modalidad
    );

    let precio = modalidadSeleccionada.price;
    this.modalidadId = modalidadSeleccionada.id;

    // Obtener la moneda de la modalidad seleccionada
    this.currencyActiva = modalidadSeleccionada.currency || 'S/.';

    this.precioTotal = Number((this.cantidadLibro * Number(precio)).toFixed(2));
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    this.precioTotalFormat = formatter.format(this.precioTotal);

    // daet1 ini
    // console.log('modalidad:' + modalidad);
    if (modalidad == 'Comercial Extranjero') {
      this.comercialMsg = 'Comercial Extranjero';
    }
    if (modalidad == 'Comercial Nacional') {
      this.comercialMsg = 'Comercial Nacional';
    }
    if (modalidad == 'Natural' || modalidad == 'N') {
      this.comercialMsg = 'Natural';
    }
    // daet1 fin
  }

  /**
   * Auto-selecciona la modalidad según la recomendación del backend (basada en geolocalización).
   * El backend devuelve recommendedModalidadId y recommendedModalidadName según la IP del visitante.
   * - Visitante de Perú (PE) → modalidad N o CN (Soles)
   * - Visitante extranjero → modalidad CE (Dólares)
   */
  autoSelectModalidadByCurrency(): void {
    if (!this.detalleLibro?.response?.list?.[0]?.modalidades) {
      return;
    }

    const item = this.detalleLibro.response.list[0];
    const modalidades = item.modalidades;

    // Usar exclusivamente la modalidad recomendada por el backend (basada en geolocalización del servidor)
    if (!item.recommendedModalidadId) {
      // console.log('💰 [FOTOGRAFIA-DETALLE] Esperando recomendación del backend...');
      return;
    }

    const modalidadRecomendada = modalidades.find(m => m.id === item.recommendedModalidadId);

    if (!modalidadRecomendada) {
      // console.log('💰 [FOTOGRAFIA-DETALLE] Modalidad recomendada no encontrada en la lista:', item.recommendedModalidadId);
      return;
    }

    // console.log('💰 [FOTOGRAFIA-DETALLE] Modalidad del backend:', item.recommendedModalidadName,
      // '- isPeruvianVisitor:', item.isPeruvianVisitor);

    // Aplicar la modalidad seleccionada
    this.modalidadActiva = modalidadRecomendada.name;
    this.modalidadId = modalidadRecomendada.id;
    this.currencyActiva = modalidadRecomendada.currency || 'S/.';

    // Recalcular precio total
    this.precioTotal = Number(
      (this.cantidadLibro * Number(modalidadRecomendada.price)).toFixed(2)
    );
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    this.precioTotalFormat = formatter.format(this.precioTotal);

    // Actualizar mensaje de modalidad comercial
    const modalidadName = modalidadRecomendada.name?.toLowerCase();
    if (modalidadName === 'ce' || modalidadName === 'comercial extranjero') {
      this.comercialMsg = 'Comercial Extranjero';
    } else if (modalidadName === 'cn' || modalidadName === 'comercial nacional') {
      this.comercialMsg = 'Comercial Nacional';
    } else {
      this.comercialMsg = 'Natural';
    }
  }

  modalidadCss(modalidad) {
    if (modalidad == this.modalidadActiva) {
      return 'active';
    }
    return '';
  }
  slickInit(e) {
    //console.log('slick initialized');
  }

  breakpoint(e) {
    //console.log('breakpoint');
  }

  afterChange(e) {
    //console.log('afterChange');
  }

  beforeChange(e) {
    //console.log('beforeChange');
  }

  sharedFacebook() {
    const url = window.location.href;
    const urlShared = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      url
    )}`;
    window.open(urlShared, '_blank');
  }

  sharedWhatsapp() {
    const url = window.location.href;
    const text = encodeURIComponent(
      'Mira esta fotografía del Archivo Histórico del Diario Oficial El Peruano: ' +
        url
    );
    const urlShared = `https://api.whatsapp.com/send?text=${text}`;
    window.open(urlShared, '_blank');
  }

  sharedTwitter() {
    const url = window.location.href;
    const text = encodeURIComponent(
      '📘 ' +
        this.detalleLibro?.response?.list?.[0]?.title +
        ' - Mira esta fotografía del Archivo Histórico del Diario Oficial El Peruano:'
    );
    const urlShared = `https://twitter.com/intent/tweet?text=${text}&url=${encodeURIComponent(
      url
    )}`;
    window.open(urlShared, '_blank');
  }

  ngOnInit(): void {
    // guarda el estado actual
    this.prevSeo = this.seo.snapshot();

    // Inicializar moneda actual
    this.currentCurrency = this.currencyService.currentCurrency;

    // Suscribirse a cambios de moneda
    this.currencySubscription = this.currencyService.currency$.subscribe(currency => {
      this.currentCurrency = currency;
      this.currencyActiva = currency.symbol;
      // console.log('💰 [FOTOGRAFIA-DETALLE] Moneda actualizada:', currency.code, currency.symbol);

      // Si ya tenemos modalidades cargadas, auto-seleccionar la correcta
      if (this.detalleLibro?.response?.list?.[0]?.modalidades) {
        this.autoSelectModalidadByCurrency();
      }
    });

    this.obtenerDetalleLibro(this.idLibro);
    // this.obtenerLibrosRecomendados(this.idLibro); // Comentado - sección de recomendados no se usa
    // nlpr ini
    this.updateMargin();
    // nlpr fin
  }

  ngOnDestroy(): void {
    // opción A: restaura lo previo (lo que hubiera antes de entrar)
    this.seo.apply(this.prevSeo);

    // Cancelar visita pendiente si el usuario se fue antes de 3 segundos
    if (this.visitaActivoId) {
      this.estadisticaService.cancelarVisita(this.visitaActivoId, 'FOTOGRAFIA');
    }

    // Limpiar suscripción al servicio de moneda
    if (this.currencySubscription) {
      this.currencySubscription.unsubscribe();
    }

    // opción B (en lugar de A): vuelve siempre a los defaults globales
    // this.seo.resetToDefaults();
  }

  // nlpr ini
  fixedContainerHeight: number = 0;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    this.updateMargin(); // Update height
  }

  // Detectar scroll para mostrar/ocultar botones sticky
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.checkMobileButtonsVisibility();
  }

  private checkMobileButtonsVisibility(): void {
    // Solo ejecutar en móvil
    if (window.innerWidth >= 1200) {
      this.showStickyButtons = false;
      return;
    }

    // Buscar los botones móviles originales
    const mobileButtons = document.querySelector(
      '.action-buttons-mobile'
    ) as HTMLElement;

    if (!mobileButtons) {
      this.showStickyButtons = false;
      return;
    }

    // Buscar el footer
    const footer = document.querySelector('app-footer') as HTMLElement;

    // Obtener posición de los botones
    const rect = mobileButtons.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Considerar la altura del header fijo (135px en mobile)
    const headerHeight = this.fixedContainerHeight || 135;

    // Los botones están visibles si su parte superior está por debajo del header
    // y su parte inferior está por encima del final de la pantalla
    const isVisible = rect.top >= headerHeight && rect.bottom <= windowHeight;

    // Verificar si el footer está visible en la pantalla
    let footerVisible = false;
    if (footer) {
      const footerRect = footer.getBoundingClientRect();
      // Footer visible si cualquier parte está dentro de la ventana
      footerVisible = footerRect.top < windowHeight && footerRect.bottom > 0;
    }

    // Verificar si llegó al final del scroll (con margen de 100px para seguridad)
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

    // Mostrar sticky buttons solo cuando:
    // - Los botones originales NO estén visibles
    // - Y el footer NO esté visible
    // - Y NO esté al final del scroll
    this.showStickyButtons = !isVisible && !footerVisible && !isAtBottom;
  }
  private updateMargin(): void {
    setTimeout(() => {
      const fixedContainer = document.querySelector(
        '.fixed-submenus'
      ) as HTMLElement;
      if (fixedContainer) {
        this.fixedContainerHeight = fixedContainer.offsetHeight;
        // console.log('Altura del header fijo: ' + this.fixedContainerHeight);

        // ✅ Aplicar margin-top dinámico a la versión desktop
        const desktopView = this.el.nativeElement.querySelector(
          '.desktop-view'
        ) as HTMLElement;
        if (desktopView) {
          // console.log('Aplicando margin-top dinámico a desktop-view');
          this.renderer.setStyle(
            desktopView,
            'margin-top',
            `${this.fixedContainerHeight}px`
          );
        }

        // Mantener lógica existente para otros contenedores (si existen)
        const contentContainerM1 = this.el.nativeElement.querySelector(
          '.container-main-detalle'
        ) as HTMLElement;
        if (contentContainerM1) {
          // console.log('Aplicando margin-top a container-main-detalle');
          this.renderer.setStyle(
            contentContainerM1,
            'margin-top',
            `${this.fixedContainerHeight}px`
          );
        }

        // ✅ Aplicar margin-top dinámico a la versión móvil
        const mobileView = this.el.nativeElement.querySelector(
          '.mobile-view'
        ) as HTMLElement;
        if (mobileView) {
          // console.log('Aplicando margin-top dinámico a mobile-view');
          this.renderer.setStyle(
            mobileView,
            'margin-top',
            `${this.fixedContainerHeight}px`
          );
        }

        const contentContainerM2 = this.el.nativeElement.querySelector(
          '.container-main-detalle-m'
        ) as HTMLElement;
        if (contentContainerM2) {
          // console.log('Aplicando margin-top a container-main-detalle-m');
          this.renderer.setStyle(
            contentContainerM2,
            'margin-top',
            `${this.fixedContainerHeight}px`
          );
        }
      }
    }, 0); // Retrasar la ejecución hasta el siguiente ciclo de eventos
  }
  // nlpr fin

  parseInt(value: any): number {
    return Number(value);
  }

  dividirEtiquetasEnFilas() {
    let filas: string[][] = [];
    let fila: string[] = [];
    this.tagPublicacion.forEach((etiqueta, index) => {
      fila.push(etiqueta);
      if (fila.length === 3 || index === this.tagPublicacion.length - 1) {
        filas.push(fila);
        fila = [];
      }
    });
    this.etiquetasAgrupadas = filas;
  }

  dividirEtiquetasEn2Columnas() {
    let filas: string[][] = [];
    let fila: string[] = [];
    this.tagPublicacion.forEach((etiqueta, index) => {
      fila.push(etiqueta);
      if (fila.length === 2 || index === this.tagPublicacion.length - 1) {
        filas.push(fila);
        fila = [];
      }
    });
    this.etiquetasAgrupadas2Col = filas;
  }

  scale: number = 1; // Factor de escala para el zoom

  onWheel(event: WheelEvent): void {
    if (event.deltaY < 0) {
      // Scroll hacia arriba (zoom in)
      this.scale += 0.1; // Aumenta el zoom
    } else {
      // Scroll hacia abajo (zoom out)
      this.scale -= 0.1; // Disminuye el zoom
    }

    // Limita el zoom dentro de un rango (por ejemplo, entre 1x y 3x)
    if (this.scale < 1) this.scale = 1;
    if (this.scale > 3) this.scale = 3;
  }

  ngAfterViewInit(): void {
    // console.log('ngAfterViewInit');
    this.updateMargin();
  }

  getTitleForModalidad(modalidad: string): string {
    const nombres = {
      N: 'Particular Nacional',
      CN: 'Comercial Nacional',
      CE: 'Comercial Extranjero',
    };
    return nombres[modalidad] || modalidad;
  }

  getModalidadDisplayName(modalidad: string): string {
    // Siempre mostrar nombre completo
    const nombres = {
      N: 'Particular Nacional',
      CN: 'Comercial Nacional',
      CE: 'Comercial Extranjero',
    };
    return nombres[modalidad] || modalidad;
  }

  getModalidadPrice(modalidad: string): string {
    if (!this.detalleLibro?.response?.list?.[0]?.modalidades) {
      return '';
    }

    const modalidadData = this.detalleLibro.response.list[0].modalidades.find(
      (m) => m.name === modalidad
    );

    if (!modalidadData || !modalidadData.price) {
      return '';
    }

    const precioNumerico =
      Number(modalidadData.price) * Number(this.cantidadLibro);
    const precio = precioNumerico.toFixed(2);
    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${modalidadData.currency || 'S/.'} ${formatter.format(
      Number(precio)
    )}`;
  }

  bloquearClickDerecho(event: MouseEvent): void {
    event.preventDefault();
    // console.log('Click derecho bloqueado en la imagen');
  }
  @HostListener('document:keydown', ['$event'])
  bloquearTeclas(event: KeyboardEvent): void {
    if (
      (event.key === 'F10' && event.shiftKey) ||
      event.key === 'ContextMenu'
    ) {
      event.preventDefault();
      // console.log('Tecla de menú contextual bloqueada');
    }
  }
  @HostListener('document:contextmenu', ['$event'])
  bloquearContextMenuGlobal(event: MouseEvent): void {
    event.preventDefault(); // Prevenir el menú contextual en cualquier lugar
    // console.log('Click derecho bloqueado globalmente');
  }

  //SEO

  // ⬇️ NUEVO: Helpers SEO dentro del componente
  // --- SEO helpers (reemplaza por esto) ---

  private setSeoFromDetalle(item: any): void {
    // Usa exactamente los campos que ya pintas en HTML
    const title =
      (item.title || item.name || item.autor || '').toString().trim() ||
      'Detalle';

    const desc = this.buildDescription(item);

    // Obtener la imagen del producto o usar el logo por defecto
    const imageUrl = this.getProtectedImageUrl(String(item.activoId));

    this.seo.setMeta({
      title, // ej: "Alonso Alegría"
      description: desc, // ej: "Lima - 26 abril 1975 / Entrevista ..."
      image: imageUrl || undefined, // Si no hay imagen del producto, usará la imagen por defecto del servicio
      og: true,
      suffix: 'Archivo Histórico | Diario Oficial El Peruano',
    });
    // Canonical dinámico basado en la URL visible
    this.seo.setCanonicalFromCurrentUrl();
  }

  private buildDescription(item: any): string {
    // Intenta "Ciudad/Diario - Año / Descripción"
    const lugar =
      item.cityName || item.city || item.lugar || item.place || item.diarioName;
    const fecha =
      item.yearName ||
      item.fechaTexto ||
      item.fechaPublicacion ||
      item.fecha ||
      item.anio;

    const partes: string[] = [];
    if (lugar) partes.push(String(lugar).trim());
    if (fecha) partes.push(String(fecha).trim());

    const prefijo = partes.join(' - ');
    const cuerpo = this.stripHtml(
      item.description || item.descripcionCorta || item.descripcion || ''
    );

    // Normaliza espacios
    const texto = ((prefijo ? `${prefijo} / ` : '') + cuerpo)
      .replace(/\s+/g, ' ')
      .trim();
    return texto;
  }

  private stripHtml(html: string): string {
    const tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return (tmp.textContent || tmp.innerText || '').trim();
  }

  // Método para activar categoría y subcategoría en el header
  private activateHeaderFromDetail(item: any): void {
    if (!item) return;

    // 📊 LOG DE DEBUG: Ver todos los valores disponibles
    // console.log('📊 [FOTOGRAFIA-DETALLE] Valores disponibles:', {
      // 'item.categoryName': item.categoryName,
      // 'item.subCategoryName': item.subCategoryName,
      // 'item.categoryId': item.categoryId,
      // 'item.subCategoryId': item.subCategoryId,
      // 'utilitarioService.idCategoria': this.utilitarioService.idCategoria,
      // 'utilitarioService.idSubCategoria': this.utilitarioService.idSubCategoria,
      // 'novedadesService.idCategoria': this.novedadesService.idCategoria,
      // 'novedadesService.idSubCategoria': this.novedadesService.idSubCategoria,
    // });

    // Prioridad 1: Usar los IDs directamente si vienen en el item
    let categoryId = item.categoryId;
    let subCategoryId = item.subCategoryId;

    // Prioridad 2: Si no hay IDs, intentar mapear desde los nombres
    if (!categoryId && item.categoryName) {
      categoryId = this.headerCommunicationService.getCategoryId(
        item.categoryName
      );
      // console.log(
        // '📝 [FOTOGRAFIA-DETALLE] CategoryId mapeado desde nombre:',
        // categoryId
      // );
    }

    if (!subCategoryId && item.subCategoryName) {
      subCategoryId = this.headerCommunicationService.getSubCategoryId(
        item.subCategoryName
      );
      // console.log(
        // '📝 [FOTOGRAFIA-DETALLE] SubCategoryId mapeado desde nombre:',
        // subCategoryId
      // );
    }

    // Prioridad 3: FALLBACK a servicios solo si todo lo anterior falla
    if (!categoryId) {
      categoryId =
        this.utilitarioService.idCategoria ||
        this.novedadesService.idCategoria ||
        '1';
      // console.log(
        // '📝 [FOTOGRAFIA-DETALLE] Usando categoryId del servicio (fallback):',
        // categoryId
      // );
    }

    if (!subCategoryId) {
      subCategoryId =
        this.utilitarioService.idSubCategoria ||
        this.novedadesService.idSubCategoria ||
        '';
      // console.log(
        // '📝 [FOTOGRAFIA-DETALLE] Usando subCategoryId del servicio (fallback):',
        // subCategoryId
      // );
    }

    // console.log('✅ [FOTOGRAFIA-DETALLE] Activando header con:', {
      // categoryId,
      // subCategoryId,
      // categoryName: item.categoryName,
      // subCategoryName: item.subCategoryName,
    // });

    // Notificar al header para que se active
    this.headerCommunicationService.setActiveCategory({
      categoryId,
      subCategoryId,
      categoryName: item.categoryName,
      subCategoryName: item.subCategoryName,
    });
  }

  // Image skeleton methods (copiados del componente fotografías)
  shouldShowSkeleton(imageId: string | number): boolean {
    if (!imageId) return false;

    // Convertir a string para uso interno
    const imageIdStr = String(imageId);

    // Si nunca se ha iniciado la carga, solo marcar como visible
    // La carga ya se hace en obtenerLibroDetalle()
    if (!this.imageLoadStartTimes.has(imageIdStr)) {
      this.imageLoadStartTimes.set(imageIdStr, Date.now());
      this.isSkeletonVisible.set(imageIdStr, true);
      return true;
    }

    return this.isSkeletonVisible.get(imageIdStr) || false;
  }

  getProtectedImageUrl(imageId: string | number): string | null {
    if (!imageId) {
      return null;
    }

    // Convertir a string para uso interno
    const imageIdStr = String(imageId);

    // Si el skeleton está visible, no mostrar imagen aún
    if (this.isSkeletonVisible.get(imageIdStr)) {
      return null;
    }

    // Si ya no está el skeleton, devolver la URL desde el cache
    return this.imageUrlCache.get(imageIdStr) || null;
  }

  getProtectedPreviewImageUrl(imageId: string | number): string | null {
    if (!imageId) {
      return null;
    }

    // Convertir a string para uso interno
    const imageIdStr = String(imageId);

    const protectedImage = this.protectedImages.get(imageIdStr);
    return protectedImage?.protectedPreviewUrl || null;
  }

  getImageOrientationClass(): string {
    if (!this.detalleLibro?.response?.list?.[0]) {
      return 'horizontal';
    }

    const item = this.detalleLibro.response.list[0];
    const imageWidth = parseInt(item.width) || 0;
    const imageHeight = parseInt(item.height) || 0;

    // Determinar orientación
    return imageHeight > imageWidth ? 'vertical' : 'horizontal';
  }

  // Método para calcular dimensiones del skeleton basado en orientación
  getSkeletonDimensions(): { width: string; height: string } {
    let imageWidth = 0;
    let imageHeight = 0;

    const item = this.detalleLibro?.response?.list?.[0];

    if (item) {
      imageWidth = parseInt(item.width) || 0;
      imageHeight = parseInt(item.height) || 0;

      // Si el item no tiene dimensiones, buscar en cache del servicio
      if ((imageWidth === 0 || imageHeight === 0) && item.activoId) {
        const cached = this.novedadesService.imageDimensionsCache.get(String(item.activoId));
        if (cached) {
          imageWidth = cached.width;
          imageHeight = cached.height;
        }
      }
    }

    // Default landscape para fotografías
    if (imageWidth === 0 || imageHeight === 0) {
      return { width: '256px', height: '168px' };
    }

    if (imageHeight > imageWidth) {
      return { width: '168px', height: '256px' };
    } else {
      return { width: '256px', height: '168px' };
    }
  }

  loadProtectedThumbnail(imageId: string): void {
    // Verificar si ya existe el token y aún es válido
    if (this.protectedImages.has(imageId)) {
      const existingImage = this.protectedImages.get(imageId);
      const now = Date.now();
      const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos de cache

      if (
        existingImage &&
        existingImage.loadedAt &&
        now - existingImage.loadedAt < CACHE_DURATION
      ) {
        // console.log('Token de imagen reutilizado desde cache:', imageId);
        return; // Ya existe y es válido
      }
    }

    // console.log('🔄 Cargando imagen de detalle:', imageId);

    // Marcar como en proceso para evitar duplicados
    this.protectedImages.set(imageId, {
      imageId: imageId,
      protectedThumbnailUrl: null,
      expiresIn: 0,
      loadedAt: Date.now(),
    });

    this.protectedImageService.getProtectedThumbnail(imageId).subscribe({
      next: (response) => {
        response.loadedAt = Date.now();
        this.protectedImages.set(imageId, response);
        // Actualizar cache de URL
        this.imageUrlCache.set(imageId, response.protectedThumbnailUrl);
        // También actualizar urlImagen para mantener compatibilidad
        this.urlImagen = response.protectedThumbnailUrl;

        // Cachear dimensiones en el servicio para que persistan entre navegaciones
        if (response.metadata && response.metadata.width && response.metadata.height) {
          this.novedadesService.imageDimensionsCache.set(imageId, {
            width: response.metadata.width,
            height: response.metadata.height
          });
        }

        // Calcular tiempo transcurrido desde que inició la carga
        const startTime = this.imageLoadStartTimes.get(imageId) || Date.now();
        const elapsedTime = Date.now() - startTime;
        const minimumDelay = 800; // 800ms mínimo para apreciar el skeleton

        // Siempre esperar el tiempo mínimo completo
        const timeToWait = Math.max(0, minimumDelay - elapsedTime);

        setTimeout(() => {
          this.isSkeletonVisible.set(imageId, false);
          this.imageReadyForDisplay.set(imageId, true);
          this.cdr.detectChanges();
          // console.log(
          //   `🖼️ Mostrando imagen de detalle después de ${minimumDelay}ms:`,
          //   imageId
          // );
        }, timeToWait);

        //console.log('✅ Token recibido para detalle:', imageId);
      },
      error: (error) => {
        console.error('❌ Error cargando imagen de detalle:', imageId, error);
        // Remover de la lista en caso de error para permitir reintento
        this.protectedImages.delete(imageId);
        this.imageLoadStartTimes.delete(imageId);
        this.isSkeletonVisible.delete(imageId);
      },
    });
  }

  // getProtectedImageUrl(imageId: string): string | null {
  //   const protectedImage = this.protectedImages.get(imageId);
  //   return protectedImage?.protectedThumbnailUrl || null;
  // }

  clearProtectedImagesCache(): void {
    // console.log('Limpiando cache de imágenes protegidas para nueva carga');
    // Solo limpiar tokens expirados en lugar de limpiar todo
    const now = Date.now();
    const CACHE_DURATION = 5 * 60 * 1000; // 5 minutos

    for (const [imageId, imageData] of this.protectedImages.entries()) {
      if (imageData.loadedAt && now - imageData.loadedAt > CACHE_DURATION) {
        this.protectedImages.delete(imageId);
        // console.log('Token expirado eliminado para imagen:', imageId);
      }
    }
  }

  isModalidadActive(modalidad: string): boolean {
    // Implementa la lógica para determinar si esta modalidad está activa
    return this.modalidadSeleccionada === modalidad;
  }

  getModalidadIcon(modalidad: string): string {
    const iconMap: { [key: string]: string } = {
      CE: 'copyright',
      CN: 'creative-commons',
      N: 'file-alt',
      Personal: 'user',
      Comercial: 'store',
      Editorial: 'newspaper',
    };

    return iconMap[modalidad] || 'cog';
  }

  // Método para obtener la fecha formateada desde los metadatos del API
  getMetadataDate(imageId: string | number): string | null {
    if (!imageId) return null;

    // Convertir a string para uso interno
    const imageIdStr = String(imageId);

    const protectedImage = this.protectedImages.get(imageIdStr);
    if (
      protectedImage &&
      protectedImage.metadata &&
      protectedImage.metadata.iptcCreated
    ) {
      const dateStr = protectedImage.metadata.iptcCreated.formatted;
      return this.formatDateToDDMMYYYY(dateStr);
    }

    return null;
  }

  // Método para formatear fecha a dd/mm/yyyy
  // Parseo manual para compatibilidad con Safari/iOS (no soporta "YYYY-MM-DD HH:mm:ss -0500")
  private formatDateToDDMMYYYY(dateString: string): string {
    try {
      // dateString viene como "1975-04-26 00:00:00 -0500"
      // Extraer directamente año, mes, día sin usar new Date() (incompatible con Safari)
      const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (match) {
        return `${match[3]}/${match[2]}/${match[1]}`;
      }
      // Fallback: intentar con Date ISO
      const isoString = dateString.replace(' ', 'T').replace(/\s([+-]\d{2})(\d{2})$/, '$1:$2');
      const date = new Date(isoString);
      if (!isNaN(date.getTime())) {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      }
      return dateString;
    } catch (error) {
      return dateString;
    }
  }

  // Método para verificar si los metadatos están disponibles
  hasMetadata(imageId: string | number): boolean {
    if (!imageId) return false;

    // Convertir a string para uso interno
    const imageIdStr = String(imageId);

    const protectedImage = this.protectedImages.get(imageIdStr);
    return !!(protectedImage && protectedImage.metadata);
  }

  // Método para formatear nombres quitando guiones bajos y agregando tildes
  formatCategoryName(categoryName: string): string {
    if (!categoryName) return '';

    // Primero quitar guiones bajos
    let formatted = categoryName.replace(/_/g, ' ');

    // Mapeo de palabras sin tilde a palabras con tilde
    const tildeMap: { [key: string]: string } = {
      FOTOGRAFIAS: 'Fotografías',
      'PORTADAS HISTORICAS': 'Portadas Históricas',
      HEMEROTECA: 'Hemeroteca',
      CULTURA: 'Cultura',
      POLITICA: 'Política',
      DEPORTES: 'Deportes',
      ESPECTACULOS: 'Espectáculos',
      REGIONES: 'Regiones',
      ECONOMIA: 'Economía',
      SOCIEDAD: 'Sociedad',
      PRESIDENTES: 'Presidentes',
      'SIGLO XIX': 'Siglo XIX',
      'SIGLO XX': 'Siglo XX',
      'SIGLO XXI': 'Siglo XXI',
    };

    // Buscar coincidencia (ignorando mayúsculas/minúsculas)
    const upperFormatted = formatted.toUpperCase();
    for (const key in tildeMap) {
      if (upperFormatted === key) {
        return tildeMap[key];
      }
    }

    // Si no se encuentra en el mapeo, capitalizar cada palabra
    return formatted
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  getFechaLabel(): string {
    const categoria = this.detalleLibro.response.list[0].categoryName;

    if (categoria === 'FOTOGRAFÍAS' || categoria === 'FOTOGRAFIAS') {
      return 'Fecha de creación';
    }
    if (categoria === 'PORTADAS_HISTORICAS') {
      return 'Fecha de publicación';
    }
    return 'Fecha de publicación'; // Por defecto
  }
}
